// @ts-nocheck
import Connect from './connect';
const _default_1: Connect = new Connect();
export default _default_1;
